import React, { useEffect } from 'react';
import { Button, Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { trackPlay } from '../utils/trackPlay';
import SEOMeta from '../components/SEOMeta';

interface GameTemplateProps {
  game: React.ComponentType;
  title: string;
  slug: string;
  hideHeader?: boolean;
}

const Title = styled.h2`
  color: white;
  font-size: 35px;
  margin-top: 4px;
`;

const GameTemplate: React.FC<GameTemplateProps> = ({
  game: GameComponent,
  title,
  slug,
  hideHeader = false,
}) => {
  const navigate = useNavigate();

  // Catat play setiap kali game page dimount — berlaku untuk semua cara akses
  useEffect(() => {
    trackPlay(slug);
  }, [slug]);

  return (
    <>
    <SEOMeta
      title={`${title} - Game Edukasi Anak`}
      description={`Mainkan ${title} di KinderGame.id. Game edukasi interaktif dan menyenangkan untuk anak usia 3-6 tahun. Gratis dan aman!`}
      path={`/${slug}`}
      jsonLd={{
        '@context': 'https://schema.org',
        '@type': 'Game',
        name: title,
        description: `Game edukasi ${title} untuk anak balita`,
        url: `https://kindergame.id/${slug}`,
        applicationCategory: 'EducationApplication',
        operatingSystem: 'All',
        offers: { '@type': 'Offer', price: '0', priceCurrency: 'IDR' },
        audience: { '@type': 'PeopleAudience', suggestedMinAge: 3, suggestedMaxAge: 6 },
      }}
    />
    {hideHeader ? (
      <GameComponent />
    ) : (
      <div style={{ padding: 20, textAlign: 'center' }}>
        <Row justify="center" style={{ margin: 0 }}>
          <Col lg={3} md={3} sm={3} xs={3}>
            <Button
              onClick={() => navigate('/')}
              style={{
                marginBottom: 20,
                border: 'none',
                background: 'transparent',
                padding: 0,
                height: 'auto',
                width: '50px',
                boxShadow: 'none',
              }}
            >
              <img
                src="/assets/images/back-button.png"
                alt="Kembali ke Permainan"
                style={{ width: '100%', maxWidth: '150px' }}
              />
            </Button>
          </Col>
          <Col lg={17} md={17} sm={17} xs={17}>
            <Title>{title}</Title>
          </Col>
          <Col lg={3} md={3} sm={3} xs={3}>
          </Col>
        </Row>
        <GameComponent />
      </div>
    )}
    </>
  );
};

export default GameTemplate;
